<template>
  <hm-content title="">
    <div slot="header">
      <hm-step :steps="steps" :step="1" disabledNext></hm-step>
    </div>
    <ul class="activity-list flex flex-wrap">
      <li
        v-for="(v, i) in list"
        :key="i"
        class="bg pointer"
        @click="nextStep(v)"
      >
        <div class="img-wrapper">
          <img :src="v.logoPath" alt="" />
        </div>
        <div
          class="activity-name "
          :class="{ active: templateType === v.templateType }"
        >
          <span class="category">{{ v.typeName }}</span>
        </div>

        <!-- <div class="activity-category flex flex-center">
          <div
            @click="nextStep(item)"
            class="flex flex-between category-name"
            v-for="(item, index) in v.nodes"
            :key="index"
          >
            <span
              class="category"
              :class="{ active: childId === item.templateType }"
              >{{ item.typeName }}</span
            >
            <div class="line" v-if="index !== v.nodes.length - 1">/</div>
          </div>
        </div> -->
      </li>
    </ul>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { setCookie, getCookie, removeCookie } from "@/utils/utils";
export default {
  components: { HmStep },
  data() {
    return {
      templateType: "",
      type: this.$route.query.type,
      list: [
        {
          logoPath:
            "https://imgcdn.hemiao100.com/ThemePictures/%E7%BA%A2%E5%8C%85%E5%8F%91%E6%94%BE%E9%80%9A%E7%9F%A5.png",
          typeName: "红包发放通知",
          templateType: "redMoney"
        },
        {
          logoPath:
            "https://imgcdn.hemiao100.com/ThemePictures/%E7%BA%A2%E5%8C%85%E6%B4%BB%E5%8A%A8%E4%B8%8A%E7%BA%BF.png",
          typeName: "红包活动上线",
          templateType: "rewardUp"
        },
        {
          logoPath:
            "https://imgcdn.hemiao100.com/ThemePictures/%E7%BA%A2%E5%8C%85%E6%B4%BB%E5%8A%A8%E4%B8%8B%E7%BA%BF.png",
          typeName: "红包活动下线",
          templateType: "rewardDown"
        },
        {
          logoPath:
            "https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%84%2046%402x.png",
          typeName: "红包活动定时推送",
          templateType: "dailyActivities"
        }
      ],
      steps: [
        {
          link: "SendMsgRule",
          name: "选择模板类型"
        },
        {
          link: "SendRuleConfig",
          name: "发送规则配置"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.type === "sendRule") {
      this.steps = [
        {
          link: "SendMsgRule",
          name: "选择模板类型"
        },
        {
          link: "SendRuleConfig",
          name: "发送规则配置"
        }
      ];
      const steps = getCookie({ key: "MSGRULESTEP" }) || {};
      if (steps && steps.hasOwnProperty("step1")) {
        this.templateType = steps.step1.templateType;
      }
    } else if (this.type === "temp") {
      this.steps = [
        {
          link: "SendMsgRule",
          name: "选择模板类型"
        },
        {
          link: "AddMessageTemp",
          name: "新建模板"
        }
      ];
      const steps = getCookie({ key: "TEMPSTEP" }) || {};
      if (steps && steps.hasOwnProperty("step1")) {
        this.templateType = steps.step1.templateType;
      }
    }
  },
  methods: {
    nextStep(row) {
      if (this.type === "sendRule") {
        let steps = getCookie({ key: "MSGRULESTEP" }) || {};
        steps.step1 = {
          templateType: row.templateType
        };
        setCookie({
          key: "MSGRULESTEP",
          data: steps
        });
        this.$router.push({
          name: "SendRuleConfig"
        });
      } else if (this.type === "temp") {
        let steps = getCookie({ key: "TEMPSTEP" }) || {};
        steps.step1 = {
          templateType: row.templateType
        };
        setCookie({
          key: "TEMPSTEP",
          data: steps
        });
        this.$router.push({
          name: "AddMessageTemp"
        });
      }
      //   if (!steps.hasOwnProperty("step1")) {
      //   } else {
      //   }
      //   this.$router.push({
      //     name: "SendRuleConfig"
      //   });
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-list {
  text-align: center;
  padding: 20px;
  .bg {
    box-shadow: 0px 0px 57px 0px rgba(237, 237, 237, 1);
    margin-right: 20px;
  }
  li {
    width: 200px;
    box-sizing: border-box;
    padding: 20px;
    transition: all linear 0.2s;
    user-select: none;

    .line {
      margin: 0 5px;
    }
    .activity-name {
      cursor: pointer;
    }
    .activity-name:hover {
      .category {
        color: #e60e6d;
      }
    }
  }
  li:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 10px 10px 20px;
  }
  .img-wrapper {
    img {
      width: 100%;
    }
  }

  .activity-name {
    color: #000;
    margin: 10px 0;
    .category-name {
      font-size: 12px;
    }
  }

  .activity-category {
    .category-name {
      font-size: 12px;
    }
  }
  .activity-name.active,
  .category.active {
    color: #e60e6d !important;
  }
}
</style>
